var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 7.7915H5.66659M7.08325 10.6248H5.66659M11.3333 4.95817H5.66659M14.1666 4.8165V12.1832C14.1666 13.3733 14.1666 13.9683 13.935 14.4229C13.7312 14.8227 13.4062 15.1478 13.0063 15.3516C12.5518 15.5832 11.9567 15.5832 10.7666 15.5832H6.23325C5.04314 15.5832 4.44808 15.5832 3.99352 15.3516C3.59368 15.1478 3.26859 14.8227 3.06486 14.4229C2.83325 13.9683 2.83325 13.3733 2.83325 12.1832V4.8165C2.83325 3.62639 2.83325 3.03134 3.06486 2.57677C3.26859 2.17693 3.59368 1.85185 3.99352 1.64812C4.44808 1.4165 5.04314 1.4165 6.23325 1.4165H10.7666C11.9567 1.4165 12.5518 1.4165 13.0063 1.64812C13.4062 1.85185 13.7312 2.17693 13.935 2.57677C14.1666 3.03134 14.1666 3.62639 14.1666 4.8165Z",
    stroke: "#39CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.1f4fa2d16f8d076ee116ce6e557c0ba7.svg";
export { ForwardRef as ReactComponent };